import { Component, HostBinding, Inject, Input, Optional } from '@angular/core';

import { EventModel, FootballScore, ScoreboardType, SportType } from '@frontend/sports/betting-offer/feature/model';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { GRID_CONFIG, GridConfig } from '@frontend/sports/grid/core/feature/config';

@Component({ template: '' })
export abstract class GridScoreboardBaseComponent {
    @Input() event: EventModel;
    scoreboardType = ScoreboardType;

    @HostBinding('class.hidden')
    get display(): boolean {
        if (!this.event.scoreboard) {
            return true;
        }

        if (this.event.scoreboard.sportType === SportType.LeaderboardGame) {
            return false;
        }

        return !this.event.scoreboard.started;
    }

    constructor(@Optional() @Inject(GRID_CONFIG) private gridConfig: GridConfig | null) {}

    get hasExtended(): boolean {
        return this.event.sport.id !== SportConstant.Basketball && !!this.gridConfig?.hasExtendedScoreboard;
    }

    get penaltyShootout(): boolean {
        return (
            (this.event.scoreboard.sportType === SportType.Football || this.event.scoreboard.sportType === SportType.PeriodGame) &&
            !!this.event.scoreboard.getScore<FootballScore>()!.penaltyShootOutScore
        );
    }

    get isSnooker(): boolean {
        return this.event.scoreboard.sportType === SportType.Snooker;
    }
}
